import { styled } from "@mui/material";
import Box from "@mui/material/Box";
import { Icon } from "../Icon";

export const StyledGameCard = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== "isSelected",
})<{
  isSelected?: boolean;
}>`
  cursor: pointer;
  min-height: calc(${({ theme }) => theme.wsc.size.l} * 3);
  display: flex;
  flex-direction: column;
  background-color: ${({ theme, isSelected }) =>
    theme.wsc.palette.neutral[isSelected ? 500 : 700]};
  border-radius: ${({ theme }) => theme.wsc.radius.m};
  border: 1px solid
    ${({ theme, isSelected }) =>
      isSelected ? theme.wsc.palette.neutral[300] : "transparent"};
  padding: ${({ theme }) => theme.wsc.spacing[2]};
  color: ${({ theme }) => theme.wsc.palette.neutral[100]};
  ${({ theme }) => theme.wsc.typography.body1bold};

  transition: all 0.15s ease;

  &:active {
    transform: scale(0.98);
  }

  &:has(> :nth-child(2):active) {
    transform: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.wsc.palette.neutral[600]};
  }
`;

export const StyledGameCardMainContainer = styled(Box)`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const StyledGameIcon = styled(Icon, {
  shouldForwardProp: (prop: string) => prop !== "isSelected",
})<{
  isSelected?: boolean;
}>`
  &&& {
    ${({ isSelected, theme: { wsc } }) => `
    transition: all 0.15s ease;
    opacity: ${isSelected ? 1 : 0};
    transform: scale(${isSelected ? 1 : 0.7});
    color: ${isSelected ? wsc.palette.neutral[0] : wsc.palette.primary[300]};
  `}
  }
`;

export const StyledGameContainer = styled(Box)`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const StyledLiveTagWrapper = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== "isLive",
})<{ isLive?: boolean }>`
  padding: 0 ${({ theme }) => theme.wsc.spacing[1]};
  visibility: ${({ isLive }) => (isLive ? "visible" : "hidden")};
`;

export const StyledSelectedIconWrapper = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== "isSelected",
})<{
  isSelected?: boolean;
}>`
  display: flex;
  align-items: center;
  transition: all 0.15s ease;
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0)};
`;
